// export const $SERVER = "http://localhost:5000";

export const $SERVER = "https://le-1755.herokuapp.com"


// export const $SERVER = "https://resas-test.herokuapp.com";

export const tokenName = "resas-1755"